webpackJsonp([171301129002626],{

/***/ 532:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Mitchell Kansas Tesla Blog","author":"Ryan Mitchell"}},"markdownRemark":{"id":"/opt/build/repo/src/pages/2018-06-26-mitch-charging-costs/index.md absPath of file >>> MarkdownRemark","html":"<p>Basically, between 6/16 and our trip back on 6/23, we had the following Supercharger charges:</p>\n<p>$2.80\n$7.70\n$1.00\n$7.90\n$2.80\n$9.00\n$7.50</p>\n<p>For a total of $38.70. That’s about the cost of one tank of fuel. The trip one way was about 658 miles. So twice that is 1,316 miles on the equivalent cost of one tank of gas. Not bad.</p>","frontmatter":{"title":"Charging costs","date":"June 26, 2018","author":"mitch"}}},"pathContext":{"slug":"/2018-06-26-mitch-charging-costs/","previous":{"fields":{"slug":"/2018-06-24-kian-fun-fun-fun/"},"frontmatter":{"title":"Fun Fun Fun!","author":"kian"}},"next":{"fields":{"slug":"/2019-03-04-should-we-blog-again/"},"frontmatter":{"title":"We might need to start blogging again","author":"mitch"}}}}

/***/ })

});


// WEBPACK FOOTER //
// path---2018-06-26-mitch-charging-costs-9965a8f6ff2f4229063d.js